

























import { Component, Vue } from 'vue-property-decorator'
import AdminLayout from '@/layouts/AdminLayout.vue'
import PageHeader from '@/components/PageHeader.vue'
import DataTable from '@/components/DataTable/DataTable.vue'
import UserModel, { UserAttribute } from '@/modules/user/user.model'
import DataTableBase from '@/classes/DataTable/DataTable'
import DataTableHeader from '@/classes/DataTable/DataTableHeader'
import DataTableFilter, { FilterOperators } from '@/classes/DataTable/DataTableFilter'
import DataTableAction from '@/classes/DataTable/DataTableAction'
import can from '@/helpers/can'
import permissions from '@/helpers/permissions'
import { AdminRoutes } from '@/helpers/getRouteMeta'
import FundingRequestModel, { FundingRequestAttribute } from '@/modules/funding-request/funding-request.model'
import { fundingRequestIndividualTypes, getFundingRequestStatusTitle, offerStatuses } from '@/helpers/fundingRequest'
import SelectField from '@/classes/Form/Fields/Select/SelectField'
import { Actions } from '@/store/global/actions'
import AreYouSureDialog from '@/components/Dialogs/AreYouSureDialog.vue'
import http from '@/http'
import IUserResponse from '@/modules/user/user-response.interface'
import { Getters } from '@/store/auth/getters'
import FundingRequestData from '@/components/DataTable/FundingRequestData.vue'

@Component({
  components: {
    DataTable,
    AdminLayout,
    PageHeader,
  },
  methods: {
    can,
  },
})
export default class RegularOffersList extends Vue {
  permissions = permissions
  selectedItems: any[] = []
  user: UserModel | null = this.$store.getters[Getters.getUser]
  selectedItemsCount: number = 0
  table = new DataTableBase()
    .setModel(FundingRequestModel)
    .setEndpoint('funding-requests-has-offers')
    .setHeaders([
      new DataTableHeader()
        .setValue(`${FundingRequestAttribute.fundingRequestNumber}`)
        .setValueParser((value) => `#${value}`)
        .setText('Nr.')
        .setSortable(true),
      new DataTableHeader()
        .setValue(`${FundingRequestAttribute.confirmed_at}`)
        .setText('Pateikimo data')
        .setSortable(false),
      new DataTableHeader()
        .setValue(`${FundingRequestAttribute.user}.${UserAttribute.fullName}`)
        .setText('Vardas ir pavardė')
        .setSortable(false),
      new DataTableHeader()
        .setValue(FundingRequestAttribute.amount)
        .setText('Paskolos suma')
        .setValueParser((value) => `${value} €`)
        .setSortable(false),
      new DataTableHeader().setValue(FundingRequestAttribute.periodData).setText('Periodas').setSortable(false),
      new DataTableHeader()
        .setValue(FundingRequestAttribute.status)
        .setText('Statusas')
        .setValueParser(getFundingRequestStatusTitle),
      new DataTableHeader()
        .setValue(FundingRequestAttribute.funding_type_name)
        .setKey(FundingRequestAttribute.funding_type)
        .setText('Tipas')
        .setValueParser((value) => value.name),
      new DataTableHeader()
        .setValue(FundingRequestAttribute.assigned_users)
        .setText('Priskirti darbuotojai')
        .setValueParser((value) => this.parseUsers(value))
        .setSortable(false),
    ])
    .setFilters([
      new DataTableFilter()
        .setOperator(FilterOperators.in)
        .setField(
          new SelectField()
            .isMultiple()
            .setKey(FundingRequestAttribute.status)
            .setTitle('Statusas')
            .setItems(offerStatuses),
        ),
      new DataTableFilter()
        .setOperator(FilterOperators.in)
        .setField(
          new SelectField()
            .isMultiple()
            .setKey(FundingRequestAttribute.filterTypeKey)
            .setTitle('Tipas')
            .setItems(fundingRequestIndividualTypes),
        ),
    ])
    .setActions([
      new DataTableAction()
        .setPermissions([permissions.fundingRequests.show])
        .setIcon('info')
        .setTitle('Informacija')
        .setAction(this.goToInformation),
      new DataTableAction()
        .setIcon('cancel')
        .setTitle('Ištrinti')
        .setPermissions([permissions.fundingRequests.delete])
        .setAction(this.onDelete),
      new DataTableAction()
        .setIcon('mdi-file-move')
        .setTitle('Archyvuoti')
        .setPermissions([permissions.fundingRequests.archive])
        .setAction(this.onArchive),
    ])
    .setIsExpandable(true)
    .setExpansionComponent(FundingRequestData)
    .setExpansionDataCallback((item) => this.fetchExpandedData(item))

  created(): void {
    if (this.user && !this.user[UserAttribute.isAdmin]) {
      this.table.setIsSelectable().setSelectBy('uuid')
    }

    if (this.user && this.user[UserAttribute.isAdmin]) {
      this.table.setHeaders([
        new DataTableHeader()
          .setValue(`${FundingRequestAttribute.fundingRequestNumber}`)
          .setValueParser((value) => `#${value}`)
          .setText('Nr.')
          .setSortable(true),
        new DataTableHeader()
          .setValue(`${FundingRequestAttribute.confirmed_at}`)
          .setText('Pateikimo data')
          .setSortable(false),
        new DataTableHeader()
          .setValue(`${FundingRequestAttribute.user}.${UserAttribute.fullName}`)
          .setText('Vardas ir pavardė')
          .setSortable(false),
        new DataTableHeader().setValue(`${FundingRequestAttribute.userEmail}`).setText('El. paštas').setSortable(false),
        new DataTableHeader()
          .setValue(`${FundingRequestAttribute.userPhone}`)
          .setValueParser((value) => `+370${value}`)
          .setText('Tel. nr.')
          .setSortable(false),
        new DataTableHeader()
          .setValue(FundingRequestAttribute.amount)
          .setText('Paskolos suma')
          .setValueParser((value) => `${value} €`)
          .setSortable(false),
        new DataTableHeader().setValue(FundingRequestAttribute.periodData).setText('Periodas').setSortable(false),
        new DataTableHeader()
          .setValue(FundingRequestAttribute.status)
          .setText('Statusas')
          .setValueParser(getFundingRequestStatusTitle),
        new DataTableHeader()
          .setValue(FundingRequestAttribute.funding_type_name)
          .setKey(FundingRequestAttribute.funding_type)
          .setText('Tipas')
          .setValueParser((value) => value.name),
        new DataTableHeader()
          .setValue(FundingRequestAttribute.assigned_users)
          .setText('Priskirti darbuotojai')
          .setValueParser((value) => this.parseUsers(value))
          .setSortable(false),
      ])
    }
  }

  goToInformation(item: FundingRequestModel): void {
    this.$router.push({
      name: AdminRoutes.offersShow,
      params: {
        uuid: item.uuid,
      },
    })
  }

  onDelete(item: FundingRequestModel): void {
    this.$store.dispatch(Actions.showDialog, {
      show: true,
      component: AreYouSureDialog,
      meta: {
        title: 'Ar tikrai norite ištrinti užklausą?',
        text: `Paspausdami taip mygtuką jūs ištrinsite finansavimo užklausą ir šis veiksmas negalės būti atšauktas.`,
        onYes: () => this.delete(item),
      },
    })
  }

  onArchive(item: FundingRequestModel): void {
    this.$store.dispatch(Actions.showDialog, {
      show: true,
      component: AreYouSureDialog,
      meta: {
        title: 'Ar tikrai norite archyvuoti užklausą?',
        text: `Paspaudus taip mygtuką pasirinkta paraiška pateks į archyvuotų paraiškų sąrašą.`,
        onYes: () => this.archiveFundingRequest(item),
      },
    })
  }

  archiveFundingRequest(item: FundingRequestModel): void {
    http.post(`funding-requests/${item.uuid}/archive`).then(async () => {
      // @ts-ignore
      this.$refs.FundingRequestDataTable.filter()
      await this.$store.dispatch(Actions.showSnackbar, {
        type: 'success',
        message: `Paraiška sėkmingai suarchyvuota`,
      })
    })
  }

  delete(item: FundingRequestModel): Promise<void> {
    return http
      .delete(`${this.table.endpoint}/${item.uuid}`)
      .then(() => this.table.removeItem(item))
      .catch(() => this.$store.dispatch(Actions.closeDialog))
  }

  handleSelectedItems(items: any[]): void {
    this.selectedItemsCount = items.length
    this.selectedItems = items.map((item) => item.uuid)
  }

  onAssignItems(): void {
    if (this.user) {
      this.$store.dispatch(Actions.showDialog, {
        show: true,
        component: AreYouSureDialog,
        meta: {
          title: 'Ar tikrai norite prisiskirti šias paraiškas?',
          text: `Paraiškos jau yra priskirtos darbuotojui ${this.user.fullName}`,
          onYes: () => this.assignItems(),
        },
      })
    }
  }

  assignItems(): void {
    if (this.user) {
      this.table.loading = true
      http.post('funding-requests/assign', this.selectedItems).then(async () => {
        // @ts-ignore
        await this.$refs.FundingRequestDataTable.filter() // refresh table data
        await this.$store.dispatch(Actions.showSnackbar, {
          type: 'success',
          message: `Paraiškos sėkmingai priskirtos! Priskirtų paraiškų kiekis: ${this.selectedItemsCount}`,
        })
        await this.unselectAll()
      })
    }
  }

  unselectAll(): void {
    this.selectedItems = []
    this.selectedItemsCount = 0
    // @ts-ignore
    this.$refs.colleaguesDataTable.clearSelectedItems()
  }

  parseUsers(items: IUserResponse[]): string {
    let parsedItems = ''
    items.forEach((item: IUserResponse, index: number) => {
      if (items.length === 1) {
        parsedItems += item.full_name

        return
      }

      if (index > 0) {
        parsedItems += item.full_name
      } else {
        parsedItems = `${parsedItems + item.full_name}, `
      }
    })

    return parsedItems
  }

  fetchExpandedData(item: FundingRequestModel): Promise<void> {
    return http.get(`/funding-requests/${item.uuid}/get-financiers-data`)
  }
}
